module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MDAiIGhlaWdodD0iNjAwIiB2aWV3Qm94PSItNzUgLTQwIDEyMCA4MCI+PHRpdGxlPkZsYWcgb2YgUGFraXN0YW48L3RpdGxlPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0tNzUtNDBINDV2ODBILTc1eiIvPjxwYXRoIGZpbGw9IiMwMTQxMUMiIGQ9Ik0tNDUtNDBoOTB2ODBoLTkweiIvPjxjaXJjbGUgcj0iMjQiIGZpbGw9IiNmZmYiLz48Y2lyY2xlIHI9IjIyIiBjeD0iLTciIGN5PSItNDAiIGZpbGw9IiMwMTQxMUMiIHRyYW5zZm9ybT0icm90YXRlKC00MS42MzQgNDUgLTQwKSIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik04Ljc1MS0xNy45NTlsMTAuMTEgMTEuMzczTDMuOTk3LTkuODQ0bDEzLjk0LTYuMS03LjY5MiAxMy4xMjl6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/pak.svg
// module id = dl2s
// module chunks = 0